import { FLOW_MODES } from '@avanta/shared/constants/appointments';
import { FIFTEEN_MINUTES } from '@avanta/shared/constants/common';
import { type Treatment } from '@avanta/shared/types/appointments';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { useWatch } from 'react-hook-form';
import { QUERY_KEYS } from 'constants/common';
import { AppointmentsReservePayload } from 'pages/AppointmentsReserve/types';
import { AppointmentService } from 'services/appointments';

export const useFetchTreatments = (): UseQueryResult<Treatment[]> => {
  const flow = useWatch({ name: AppointmentsReservePayload.flow });
  return useQuery({
    queryKey: [QUERY_KEYS.FETCH_TREATMENTS],
    queryFn: () => AppointmentService.getTreatments(),
    select: response => response.data,
    staleTime: FIFTEEN_MINUTES,
    enabled: flow !== FLOW_MODES.search,
  });
};
